/**
 * CRMロールを持つユーザーのみアクセス可能なルートを保護するコ��ポーネント
 *
 * @param {object} props コンポーネントプロパティ
 * @param {ReactNode} props.children 子要素
 * @param {"viewer" | "editor" | "admin"} [props.requiredRole] 必要な最低CRMロール（デフォルト: viewer）
 * @return {JSX.Element} ルートガード結果
 */
import { type FC, type ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../hooks/authProvider/authProvider";
import { useCrmPermission } from "../hooks/useCrmPermission";
import { type CrmRole, hasCrmRoleOrAbove } from "../utils/crm-utils";

type CrmRouteProps = {
  children: ReactNode;
  requiredRole?: CrmRole;
};

export const CrmRoute: FC<CrmRouteProps> = ({
  children,
  requiredRole = "viewer",
}) => {
  const { currentUser, isLoadingUser } = useContext(AuthContext);
  const { hasCrmAccess, crmRole } = useCrmPermission();

  // ローディング中
  if (isLoadingUser) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <span className="loading loading-spinner loading-lg" />
      </div>
    );
  }

  // ユーザーがログインしていない
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // CRMアクセス権がない
  if (!hasCrmAccess) {
    return <Navigate to="/crm/access-denied" replace />;
  }

  // 必要なロールレベルを満たしていない
  if (!hasCrmRoleOrAbove(crmRole, requiredRole)) {
    return <Navigate to="/crm/access-denied" replace />;
  }

  return <>{children}</>;
};

export default CrmRoute;
